import DashboardEntry from './DashboardEntry';

export default DashboardEntry;
